import { ENGINE_MATCHER_ENDS_WITH } from '../../logger/constants';
import { endsWith } from '../../utils/lang';
export function endsWithMatcherContext(log, ruleAttr) {
    return function endsWithMatcher(runtimeAttr) {
        var strEndsWith = ruleAttr.some(function (e) { return endsWith(runtimeAttr, e); });
        log.debug(ENGINE_MATCHER_ENDS_WITH, [runtimeAttr, ruleAttr, strEndsWith]);
        return strEndsWith;
    };
}
